<template>
  <ds-rollover ref="rollover" title="Exportar dados">
    <ds-page>
      <ds-form
        ref="form"
        :submit-action="onSubmit"
        :error-message="errorMessage"
        @submit-success="onSubmitSuccess"
        @submit-error="onSubmitError">
        <ds-helper-slimbox
          class="ds-u-margin-bottom"
          title="Selecione o que deseja exportar!"
          illustration="export-book">
          <ds-p>
            Aqui estão os principais relatórios,
            defina o intervalo de datas e clique em exportar dados.
          </ds-p>
        </ds-helper-slimbox>
        <ds-row class="ds-u-margin-top">
          <ds-col size="3">
            <ds-field label="Selecione a empresa">
              <employer-multiple-select
                :employers-selected-current="backupRequest.employers"
                @change-employers-selected="onChangeEmployers">
              </employer-multiple-select>
            </ds-field>
          </ds-col>
          <ds-col size="3">
            <ds-field label="Competência inicial">
              <ds-date-input
                v-model="backupRequest.startPeriod"
                type="monthFull"
                required>
              </ds-date-input>
            </ds-field>
          </ds-col>
          <ds-col size="3">
            <ds-field label="Competência final">
              <ds-date-input
                v-model="backupRequest.endPeriod"
                type="monthFull"
                required>
              </ds-date-input>
            </ds-field>
          </ds-col>
        </ds-row>

        <ds-row>
          <ds-col size="12" align="right">
            <ds-p>
              Para acessar mais relatórios,
              <ds-link @click="goToReportsPage">acesse a página de relatórios</ds-link>
            </ds-p>
          </ds-col>
        </ds-row>

        <ds-row>
          <ds-col>
            <ds-table>
              <ds-tr slot="header">
                <ds-th size="11">Nome do relatório</ds-th>
                <ds-th size="1"></ds-th>
              </ds-tr>
              <ds-tr
                v-for="reportType in reportTypes"
                :key="reportType.name">
                <ds-td> {{ reportType.description }}</ds-td>
                <ds-td>
                  <ds-switch
                    v-model="reportType.marked"
                    mini>
                  </ds-switch>
                </ds-td>
              </ds-tr>
            </ds-table>
          </ds-col>
        </ds-row>

        <ds-footer justify="space-between">
          <ds-button @click="close">Cancelar</ds-button>
          <ds-submit-button>Exportar dados</ds-submit-button>
        </ds-footer>
      </ds-form>
    </ds-page>
  </ds-rollover>
</template>
<script>
import { dialogService, toasterService } from 'packages/common/ds-components';
import EmployerMultipleSelect from 'packages/components/common-form-selects/employer-select/EmployerMultipleSelect.vue';
import { getBoxInformationErrorMessage } from 'packages/common';
import { REPORT_TYPES } from '../constants';
import { requestBackup, mapReportTypesSelected, validateSelectedReports } from '../backupRequestService';

const BackupRequestRollover = {
  name: 'BackupRequestRollover',
  components: {
    EmployerMultipleSelect,
  },
  data() {
    return {
      errorMessage: null,
      backupRequest: {
        reportTypes: new Set(),
        tenantIds: [],
      },
      reportTypes: REPORT_TYPES.map(r => { return { ...r, marked: true }; }),
    };
  },
  methods: {
    onSubmit() {
      this.errorMessage = null;
      const reportTypesRequested = mapReportTypesSelected(this.reportTypes);
      const request = {
        ...this.backupRequest,
        reportTypes: reportTypesRequested,
      };
      return validateSelectedReports(reportTypesRequested)
        .then(() => requestBackup(request));
    },
    onSubmitSuccess() {
      toasterService.success({
        title: 'Solicitação realizada com sucesso!',
        content: 'O relatório está sendo gerado',
      });
      this.$emit('submit-success');
      this.close();
    },
    onSubmitError(error) {
      this.scrollToFormTop();
      const message = error?.custom ? error : getBoxInformationErrorMessage(error);
      this.errorMessage = message;
    },
    scrollToFormTop() {
      setTimeout(() => {
        this.$refs.form.$el.scrollIntoView();
      }, 100);
    },
    onChangeEmployers(employers) {
      const ids = employers?.map(e => e.tenantId);
      this.backupRequest.tenantIds = ids;
    },
    goToReportsPage() {
      this.close();
      this.$router.push({ name: 'ReportCenter' });
    },
    close() {
      this.$refs.rollover.close();
    },
  },
};

BackupRequestRollover.open = dialogService.buildOpenDialog(BackupRequestRollover);

export default BackupRequestRollover;
</script>
